export const RebulkLogo = ({ className }: { className?: string }) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 470.12 558.16"
    className={className}
  >
    <path
      fill="currentColor"
      d="M292.61,320.72c46.14-11.67,72.66-37.13,72.66-83.27v-45.61c0-68.42-56.22-92.82-146.92-92.82h-119.34v358.54c23.34,2.12,54.1,2.12,77.44,0v-128.89h38.72c30.23,41.37,55.16,87.52,74.78,128.89,22.81,2.12,58.34,2.12,81.15,0-20.69-44.02-46.67-93.35-78.5-136.84ZM176.45,263.44l-77.44,65.41V99.02s77.44,65.41,77.44,65.41v99.02ZM206.92,249.9l-30.47,13.54v-99.02l28.85,12.83,82.53,36.68-80.92,35.96Z"
    />
    <polygon
      fill="#fdc11a"
      points="99.02 328.86 176.45 263.44 176.45 164.43 99.02 99.02 99.02 328.86"
    />
  </svg>
)

export default RebulkLogo
